import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	fastshiftChampionCardTitle: {
		id: 'fastshift.relationships-card.title.fastshift-champion',
		defaultMessage: 'Your FastShift Champion',
		description: 'Title for the FastShift champion card',
	},
	fastshiftChampionCardSubtitle: {
		id: 'fastshift.relationships-card.subtitle.fastshift-champion',
		defaultMessage: 'A dedicated expert for migration topics',
		description: 'Subtitle for the FastShift champion card',
	},
	fastshiftChampionTitle: {
		id: 'fastshift.relationships-card.relationship-name.fastshift-champion',
		defaultMessage: '{title}',
		description: 'Name of the FastShift champion',
	},
});
